import styles from "./Takers.module.scss";
import ArrowSVG from "../assets/arrow-up-right-dark.svg";
import { Bubbles } from "./Bubbles";

export const Takers = () => {
  return (
    <div className={styles.takers}>
      <div>
        <div className={styles.content}>
          <h4>For takers</h4>
          <div>
            <h2>Plug into</h2>
            <h2 className={`gradient semibold`}>better liquidity</h2>
          </div>
          <div className={styles.description}>
            <div>
              <h6>No Slippage. No MEV. No Surprises</h6>
              <p>
                Hashflow’s RFQ engine gives your users the exact price they’re
                quoted—always. Eliminate failed trades, toxic flow, and broken
                UX.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
            <div>
              <h6>One Integration. All the Liquidity.</h6>
              <p>
                Access a network of 25+ top-tier market makers across every
                major chain—through a single, seamless integration.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
            <div>
              <h6>Built Around Your Flow.</h6>
              <p>
                Need deep coverage in niche markets? Or broad liquidity across
                multiple assets? Hashflow tailors liquidity to match your unique
                demand profile.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.fixed}>
          <div className={styles.sticky}>
            <Bubbles />
          </div>
        </div>
      </div>
    </div>
  );
};
